module.exports = __webpack_public_path__ + "static/media/16.6f6dd449.jpg";